/**
 * Custom fetch wrapper that gzip-compresses large request bodies.
 * Uses the browser's native CompressionStream API (no library needed).
 *
 * Only compresses POST/PUT/PATCH requests with JSON bodies exceeding the size threshold.
 */

const COMPRESSION_THRESHOLD = 100 * 1024; // 100KB - compress bodies larger than this

async function compressBody(body: string): Promise<Blob> {
    const stream = new Blob([body]).stream();
    const compressedStream = stream.pipeThrough(new CompressionStream('gzip'));
    return new Response(compressedStream).blob();
}

export async function gzipFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    // Only compress string bodies (JSON) that exceed the threshold
    if (init?.body && typeof init.body === 'string' && init.body.length > COMPRESSION_THRESHOLD) {
        const compressed = await compressBody(init.body);
        const headers = new Headers(init.headers);
        headers.set('Content-Encoding', 'gzip');
        headers.set('Content-Type', 'application/json');

        return fetch(input, {
            ...init,
            headers,
            body: compressed,
        });
    }

    return fetch(input, init);
}
